import axios, { type AxiosRequestConfig, type AxiosResponse, type AxiosStatic } from 'axios';

export default {
  ...axios,
  get: async <T = unknown, R = AxiosResponse<T>, D = unknown, P = unknown>(url: string, config?: AxiosRequestConfig<D, P>) => {
    const params = { _: Date.now(), ...config?.params } as P;
    const headers = { 'X-Requested-With': 'XMLHttpRequest', ...config?.headers };
    try {
      return await axios.get<T, R, D, P>(url, config ? { ...config, params, headers } : { params, headers });
    } catch (error) {
      if (window.Sentry && error.response) {
        window.Sentry.captureException(error);
      }
      throw error;
    }
  },
} as AxiosStatic;
